import script from "./notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./notifications.vue?vue&type=script&setup=true&lang=js"

import "./notifications.vue?vue&type=style&index=0&id=3a2a4373&lang=css"

const __exports__ = script;

export default __exports__